import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import "normalize.css/normalize.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.css'
import 'font-awesome/css/font-awesome.min.css'
import https from '@/request'
import api from '@/api'

Vue.config.productionTip = false
Vue.prototype.$https = https
Vue.prototype.$api = api
Vue.use(ElementUI)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
